import React from "react";
import Breadcrumb from "../../breadcrumb/breadcrumb";
import PropTypes from "prop-types";
import "./breadcrumbHeader.scss";

const BreadcrumbHeader = ({ breadcrumbLinks, title }) => {
  return (
    <div className="breadcrumb-header">
      <div className="width-wrapper">
        <Breadcrumb
          breadcrumbLinks={breadcrumbLinks}
          className="new-breadcrumb"
        />
        <h1 className="title rajdhani-font">{title}</h1>
      </div>
    </div>
  );
};

BreadcrumbHeader.propTypes = {
  breadcrumbLinks: PropTypes.object,
  title: PropTypes.string,
};

export default BreadcrumbHeader;
